import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import './TopBar.css';

const TopBar = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
    const { t, i18n } = useTranslation();
    const { user } = useAuth();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className="topbar">
            <div className="topbar-content">
                <div className="topbar-left">
                    <button
                        className="mobile-menu-btn"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <span className="material-icons">
                            {isMobileMenuOpen ? 'close' : 'menu'}
                        </span>
                    </button>
                    <button className="services-btn">
                        <span className="material-icons">apps</span>
                        {t('topbar.systemName')}
                    </button>
                </div>

                <div className="topbar-right">
                    <div className="language-pill">
                        <button
                            className={`lang-option ${i18n.language === 'en' ? 'active' : ''}`}
                            onClick={() => changeLanguage('en')}
                        >
                            EN
                        </button>
                        <button
                            className={`lang-option ${i18n.language === 'ar' ? 'active' : ''}`}
                            onClick={() => changeLanguage('ar')}
                        >
                            AR
                        </button>
                    </div>

                    <NavLink
                        to={user?.role === 'admin' ? '/admin/profile' : '/teacher/profile'}
                        className="user-profile-link"
                        title={t('profile.title')}
                    >
                        <div className="user-profile">
                            <div className="user-info">
                                <span className="user-name">
                                    {i18n.language === 'ar' ? user?.fullNameAr : (user?.fullNameEn || user?.fullNameAr)}
                                </span>
                            </div>
                            <div className="user-avatar">
                                <span className="material-icons">account_circle</span>
                            </div>
                        </div>
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default TopBar;

